import { render, staticRenderFns } from "./OurPartnersComponent.vue?vue&type=template&id=18128766&scoped=true&"
import script from "./OurPartnersComponent.vue?vue&type=script&lang=js&"
export * from "./OurPartnersComponent.vue?vue&type=script&lang=js&"
import style0 from "./OurPartnersComponent.vue?vue&type=style&index=0&id=18128766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18128766",
  null
  
)

export default component.exports